import { __assign, __rest } from "tslib";
import React, { useRef, useContext } from 'react';
import { MeasuredContainer, ScreenSizeContext, } from '../Measured';
import useScreenBounds from '../utils/hooks/useScrollableContainerBounds';
import { default as Grid } from './Grid';
import { SCROLL_TIMEOUT, VISIBLE_PADDING } from './constants';
var MeasuredGrid = function (_a) {
    var cookieType = _a.cookieType, measureWindow = _a.measureWindow, enableScrollOptim = _a.enableScrollOptim, gridProps = __rest(_a, ["cookieType", "measureWindow", "enableScrollOptim"]);
    var containerRef = useRef(null);
    var windowBounds = useScreenBounds(containerRef, SCROLL_TIMEOUT, VISIBLE_PADDING, enableScrollOptim);
    var screenWidth = useContext(ScreenSizeContext);
    return (React.createElement("div", { ref: containerRef },
        React.createElement(MeasuredContainer, { listenOnWindow: true, limitToParentWidth: true, cookieType: cookieType, cookieDim: "width", measureWindow: measureWindow }, function (props) { return (React.createElement(Grid, __assign({}, gridProps, { ref: props.onRef, bounds: windowBounds, containerWidth: props.container && props.container.width, screenWidth: screenWidth }))); })));
};
MeasuredGrid.displayName = 'MeasuredGrid';
export default MeasuredGrid;
//# sourceMappingURL=MeasuredGrid.js.map